import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle, Microscope } from 'lucide-react';
export function OldSolutions() {
  const solutions = [{
    failed: 'Tés del supermercado',
    truth: 'La mayoría contiene muy poca concentración de planta real. Es básicamente agua caliente con aroma. No es suficiente para enviar una señal real de calma a tu sistema nervioso.'
  }, {
    failed: 'Melatonina o pastillas para dormir',
    truth: 'Pueden forzar el sueño. pero no apagan el sistema nervioso. Por eso muchas mujeres: Se despiertan aturdidas, Sienten el corazón acelerado o el ciclo vuelve la noche siguiente'
  }, {
    failed: '"Intentar no pensar"',
    truth: 'Neurológicamente es casi imposible. Tu cerebro no puede obedecer una orden negativa.Antes necesita recibir una señal física de seguridad.'
  }, {
    failed: 'Apps de meditación / respiración',
    truth: 'Pueden ayudar a largo plazo. Pero cuando estás en colapso a las 11 PM con la mente acelerada, necesitas algo que actúe en minutos, no en meses..'
  }];
  return <section className="px-6 py-5 max-w-4xl mx-auto" data-id="element-374">
      <p className=" text-center font-bold text-[#4A5D3A]" data-id="element-375">
        Antes de mostrarte qué sí funciona, veamos por qué tantas cosas fallan.
      </p>
      <br data-id="element-376" />

      <p data-id="element-377">Si ya intentaste relajarte… pero nada funcionó, no es tu culpa.</p>
      <br data-id="element-378" />
      <p data-id="element-379">
        El problema es que la mayoría de las soluciones no actúan donde
        realmente ocurre el problema: tu sistema nervioso.
      </p>
      <br data-id="element-380" />
      <p className=" text-center font-bold text-[#4A5D3A]" data-id="element-381">
        {' '}
        Por eso muchas veces ocurre esto:
      </p>
      <FadeIn data-id="element-382">
        <div className="space-y-4" data-id="element-383">
          {solutions.map((item, index) => <div key={index} className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-[#4A5D3A]/10 flex flex-col md:flex-row gap-6 items-start" data-id="element-384">
              <div className="md:w-1/3 flex items-start gap-3" data-id="element-385">
                <XCircle className="text-[#9B4F2B] shrink-0 mt-1" size={24} data-id="element-386" />
                <h3 className="font-bold text-lg text-[#2D2A26]" data-id="element-387">
                  {item.failed}
                </h3>
              </div>
              <div className="md:w-2/3 flex items-start gap-3" data-id="element-388">
                <Microscope className="text-[#4A5D3A] shrink-0 mt-1" size={24} data-id="element-389" />
                <p className="text-[#2D2A26]/80 leading-relaxed" data-id="element-390">
                  {item.truth}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-10 text-center space-y-3" data-id="element-391">
          <p className="text-2xl md:text-3xl font-serif font-bold text-[#9B4F2B]" data-id="element-392">
            El problema nunca fuiste tú.
          </p>
          <p className="text-xl md:text-2xl font-bold text-[#4A5D3A]" data-id="element-393">
            El problema es que nadie te enseñó el protocolo correcto.
          </p>
          <p className="font-bold text-2xl text-[#4A5D3A] mb-2" data-id="element-394">
            Tu sistema nervioso tiene un interruptor biológico.
          </p>
          <p className="font-bold text-2xl text-[#4A5D3A] mb-6" data-id="element-395">
            Y cuando recibe la señal correcta
          </p>
          <p className="font-bold text-2xl text-[#4A5D3A] mb-6" data-id="element-396">
            sabe exactamente cómo volver a la calma.
          </p>
          <p className="text-[#4A5D3A] mb-2 text-[16px] font-[600]" data-id="element-397">
            Y esa señal puede venir de algo muy simple:
          </p>
          <p className="font-bold text-[#4A5D3A] mb-2 text-[16px]" data-id="element-398">
            las plantas correctas, preparadas de la forma correcta.
          </p>
        </div>
      </FadeIn>
    </section>;
}